export function sortOrder(arrayToSort: ProductBadge[], sortOrder: ProductBadge[]) {
  return [...arrayToSort].toSorted((a, b) => {
    const aIndex = sortOrder.indexOf(a)
    const bIndex = sortOrder.indexOf(b)

    return aIndex - bIndex
  })
}
